import { RemoveItemsList } from "./RemoveItemsList";
export default RemoveItemsList;